(function () {
  var root = document.querySelector('[data-category-results-container]') ||
    document.querySelector('[data-results-partial="category-list"]') ||
    document.getElementById('categoryResultsRegion');
  if (!root) return;

  var filterKeys = ['location', 'category', 'price', 'rating', 'instantbook', 'occasion'];
  var categoryFilterQueryParam = root.getAttribute('data-category-filter-param') || 'category';
  var knownLocationSegments = ['victoria', 'new-south-wales', 'south-australia', 'queensland', 'northern-territory', 'western-australia', 'tasmania', 'act'];
  var sortLabels = {
    popular: 'Best Sellers',
    relevance: 'Relevance',
    'price-asc': 'Lowest Price',
    'price-desc': 'Highest Price'
  };
  var sortTokensByLabel = {
    'best sellers': 'popular',
    'relevance': 'relevance',
    'lowest price': 'price-asc',
    'highest price': 'price-desc'
  };

  var partialEndpoint = root.getAttribute('data-partial-endpoint') || '/api/category-results.asp';
  var filterRequestDebounceMs = 250;
  var filterBarSentinel = document.getElementById('categoryFilterBarSentinel');
  var filterBar = document.getElementById('categoryFilterBar');
  var pageHeader = document.querySelector('.header');
  var filterBarInitialOffsetTop = filterBar ? (filterBar.getBoundingClientRect().top + window.scrollY) : 0;
  var desktopPanels = document.getElementById('desktopFilterPanels');
  var desktopFilterOverlay = desktopPanels ? desktopPanels.querySelector('[data-desktop-filter-overlay]') : null;
  var mobileSheets = document.getElementById('mobileFilterSheets');
  var mobileSheetOverlay = mobileSheets ? mobileSheets.querySelector('[data-mobile-sheet-overlay]') : null;
  var mobileSheetDialog = mobileSheets ? mobileSheets.querySelector('[data-mobile-sheet]') : null;
  var mobileSheetTitle = mobileSheets ? mobileSheets.querySelector('[data-mobile-sheet-title]') : null;
  var mobileSheetBody = mobileSheets ? mobileSheets.querySelector('[data-mobile-sheet-body]') : null;
  var activeMobileGroup = '';
  var mobileSheetAnimationTimer = null;
  var desktopCloseTimer = null;
  var partialRequestContext = readPartialRequestContext();
  var requestNonce = 0;
  var inFlightController = null;
  var pendingLoadTimer = null;
  var lastRequestedState = null;
  var lastFocusedElement = null;
  var filterBarStickyObserver = null;
  var filterBarStickyFallbackBound = false;
  var filterBarStickyEventsBound = false;
  var filterBarStickyRefreshScheduled = false;
  var pageContextType = (root.getAttribute('data-context-page-type') || '').toLowerCase();
  var publicBaseSegment = (root.getAttribute('data-public-base-segment') || '').toLowerCase();
  var knownCategorySlugs = buildLookup(root.getAttribute('data-known-category-slugs'));
  var knownSubCategorySlugs = buildLookup(root.getAttribute('data-known-subcategory-slugs'));
  var knownOccasionSlugs = buildLookup(root.getAttribute('data-known-occasion-slugs'));
  var knownFeatureSlugs = buildLookup(root.getAttribute('data-known-feature-slugs'));
  var knownLocationSlugs = buildLookup('victoria|new-south-wales|south-australia|queensland|northern-territory|western-australia|tasmania|act');
  var activeFeatureSegment = (root.getAttribute('data-context-feature') || '').toLowerCase();
  var appliedState = normalizeState(readStateFromUrl(window.location.search));
  var stagedState = cloneState(appliedState);
  var filterOptionLabels = buildFilterOptionLabels();
  var statusAnnouncer = ensureStatusAnnouncer();

  function buildLookup(pipeDelimited) {
    var lookup = Object.create(null);
    String(pipeDelimited || '')
      .split('|')
      .map(function (entry) {
        return entry.trim().toLowerCase().split(',')[0];
      })
      .filter(function (entry) { return entry.length > 0; })
      .forEach(function (entry) {
        lookup[entry] = true;
      });
    return lookup;
  }

  function syncEditorialVisibility() {
    var modeHeader = root.querySelector('[data-page-mode]');
    var suppress = modeHeader && modeHeader.getAttribute('data-suppress-editorial') === 'true';
    var hero = document.getElementById('categoryHeroSection');
    var editorialHeader = document.getElementById('categoryEditorialHeader');
    var enhancedEditorial = document.querySelector('.enhanceddetail');
    if (hero) hero.classList.toggle('hidden', !!suppress);
    if (editorialHeader) editorialHeader.classList.toggle('hidden', !!suppress);
    if (enhancedEditorial) enhancedEditorial.classList.toggle('hidden', !!suppress);
  }

  function syncResultsCount() {
    var resultsRegion = root.querySelector('[data-results-partial="category-list"]') || root.querySelector('.category-results-region');
    if (!resultsRegion) return;

    var totalRecords = resultsRegion.getAttribute('data-total-records');
    var label = resultsRegion.getAttribute('data-results-label') || 'experiences';
    if (totalRecords === null) return;

    document.querySelectorAll('[data-category-results-count]').forEach(function (container) {
      var numberNode = container.querySelector('[data-category-results-count-number]');
      var labelNode = container.querySelector('[data-category-results-count-label]');

      if (numberNode) numberNode.textContent = totalRecords;
      if (labelNode) labelNode.textContent = label;
    });
  }

  function ensureStatusAnnouncer() {
    var announcer = document.getElementById('categoryFilterLiveStatus');
    if (announcer) return announcer;
    announcer = document.createElement('div');
    announcer.id = 'categoryFilterLiveStatus';
    announcer.className = 'sr-only';
    announcer.setAttribute('aria-live', 'polite');
    announcer.setAttribute('aria-atomic', 'true');
    root.parentNode.insertBefore(announcer, root);
    return announcer;
  }

  function announceStatus(message) {
    if (!statusAnnouncer) return;
    statusAnnouncer.textContent = message || '';
  }

  function cloneState(state) {
    return {
      filters: {
        location: state.filters.location.slice(),
        category: state.filters.category.slice(),
        price: state.filters.price.slice(),
        rating: state.filters.rating.slice(),
        instantbook: state.filters.instantbook.slice(),
        occasion: state.filters.occasion.slice()
      },
      sort: state.sort,
      page: state.page,
      items: state.items
    };
  }

  function setFilterBarStickyState(isStuck) {
    if (!filterBar) return;

    var shouldStick = !!isStuck;
    if (filterBar.classList.contains('is-stuck') === shouldStick) {
      return;
    }

    filterBar.classList.toggle('is-stuck', shouldStick);
    syncFilterBarStickyLayout();
  }

  function syncFilterBarStickyLayout() {
    if (!filterBar || !filterBarSentinel) return;

    if (window.matchMedia('(max-width: 767px)').matches && filterBar.classList.contains('is-stuck')) {
      filterBarSentinel.style.height = filterBar.offsetHeight + 'px';
      return;
    }

    filterBarSentinel.style.height = '1px';
  }

  function shouldStickFilterBar(sentinelTop, filterBarBottom) {
    var isCurrentlyStuck = filterBar && filterBar.classList.contains('is-stuck');
    var isMobileViewport = window.matchMedia('(max-width: 767px)').matches;
    var stickThreshold = 0;
    var unstickThreshold = isMobileViewport ? 48 : 8;
    var pageHeaderBottom = 0;
    var pageHeaderHeight = 0;

    if (isMobileViewport && window.scrollY <= 60) {
      return false;
    }

    if (isMobileViewport && pageHeader) {
      pageHeaderBottom = pageHeader.getBoundingClientRect().bottom;
      pageHeaderHeight = pageHeader.getBoundingClientRect().height;

      if (window.scrollY <= Math.max(filterBarInitialOffsetTop - pageHeaderHeight, 0)) {
        return false;
      }

      if (pageHeaderBottom > 0) {
        return false;
      }
    }

    // Mobile becomes fixed only after this check; a fast scroll can already
    // have moved the unfixed bar above the viewport.
    if (!isMobileViewport && filterBarBottom <= 0) {
      return false;
    }

    if (isCurrentlyStuck) {
      return sentinelTop < unstickThreshold;
    }

    return sentinelTop < stickThreshold;
  }

  function refreshFilterBarStickyState() {
    if (!filterBar || !filterBarSentinel) return;

    if (!filterBar.classList.contains('is-stuck')) {
      filterBarInitialOffsetTop = filterBar.getBoundingClientRect().top + window.scrollY;
    }

    var sentinelRect = filterBarSentinel.getBoundingClientRect();
    var filterBarRect = filterBar.getBoundingClientRect();
    setFilterBarStickyState(shouldStickFilterBar(sentinelRect.top, filterBarRect.bottom));
  }

  function scheduleFilterBarStickyRefresh() {
    if (filterBarStickyRefreshScheduled) {
      return;
    }

    filterBarStickyRefreshScheduled = true;
    window.requestAnimationFrame(function () {
      filterBarStickyRefreshScheduled = false;
      refreshFilterBarStickyState();
    });
  }

  function bindFilterBarStickyState() {
    if (!filterBar || !filterBarSentinel) return;

    if (!filterBarStickyEventsBound) {
      window.addEventListener('scroll', scheduleFilterBarStickyRefresh, { passive: true });
      window.addEventListener('resize', scheduleFilterBarStickyRefresh);
      filterBarStickyEventsBound = true;
    }

    if ('IntersectionObserver' in window) {
      filterBarStickyObserver = new IntersectionObserver(function (entries) {
        if (!entries || !entries.length) return;
        var entry = entries[0];
        setFilterBarStickyState(shouldStickFilterBar(entry.boundingClientRect.top, filterBar.getBoundingClientRect().bottom));
      }, {
        threshold: [0, 1]
      });

      filterBarStickyObserver.observe(filterBarSentinel);
      refreshFilterBarStickyState();
      return;
    }

    if (!filterBarStickyFallbackBound) {
      window.addEventListener('scroll', refreshFilterBarStickyState, { passive: true });
      filterBarStickyFallbackBound = true;
    }

    refreshFilterBarStickyState();
  }

  function splitCsv(value) {
    if (!value) return [];
    return value
      .split(',')
      .map(function (entry) { return entry.trim().toLowerCase(); })
      .filter(function (entry) { return entry.length > 0; });
  }

  function titleCaseWords(value) {
    return String(value || '')
      .split('-')
      .map(function (segment) {
        return segment ? segment.charAt(0).toUpperCase() + segment.slice(1) : '';
      })
      .join(' ');
  }

  function trimTrailingSlash(pathname) {
    if (!pathname || pathname === '/') return '/';
    return pathname.charAt(pathname.length - 1) === '/'
      ? pathname.slice(0, -1)
      : pathname;
  }

  function ensureTrailingSlash(pathname) {
    if (!pathname || pathname === '/') return '/';
    return pathname.charAt(pathname.length - 1) === '/'
      ? pathname
      : pathname + '/';
  }

  function isKnownLocationSegment(segment) {
    return knownLocationSegments.indexOf(String(segment || '').toLowerCase()) > -1;
  }

  function syncPrimaryNavLocationLinks() {
    var selectedLocation = appliedState.filters.location.length === 1
      ? appliedState.filters.location[0]
      : '';

    document.querySelectorAll('.header .primary .megamenu > .sub a[href^="/"]').forEach(function (anchor) {
      var basePath = anchor.getAttribute('data-location-link-base');
      var suffix = anchor.getAttribute('data-location-link-suffix');

      if (!basePath) {
        var url = new URL(anchor.getAttribute('href'), window.location.origin);
        var pathSegments = trimTrailingSlash(url.pathname)
          .split('/')
          .filter(function (segment) { return segment.length > 0; });

        if (pathSegments.length > 1 && isKnownLocationSegment(pathSegments[pathSegments.length - 1])) {
          pathSegments.pop();
        }

        basePath = pathSegments.length > 0 ? '/' + pathSegments.join('/') : '/';
        suffix = (url.search || '') + (url.hash || '');

        anchor.setAttribute('data-location-link-base', basePath);
        anchor.setAttribute('data-location-link-suffix', suffix);
      }

      var nextPath = selectedLocation
        ? trimTrailingSlash(basePath) + '/' + selectedLocation
        : basePath;

      anchor.setAttribute('href', ensureTrailingSlash(nextPath) + (suffix || ''));
    });
  }

  function buildFilterOptionLabels() {
    var labels = {};
    document.querySelectorAll('[data-filter-option]').forEach(function (input) {
      var group = input.getAttribute('data-filter-group');
      var value = (input.value || '').toLowerCase();
      if (!group || !value) return;
      if (!labels[group]) labels[group] = {};
      if (labels[group][value]) return;

      var label = '';
      var inputLabel = input.closest('label');
      if (inputLabel) {
        label = inputLabel.textContent || '';
      }

      labels[group][value] = label.trim() || titleCaseWords(value);
    });
    return labels;
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getFilterGroupLabel(group) {
    var trigger = document.querySelector('[data-filter-group="' + group + '"]');
    if (trigger) {
      return trigger.getAttribute('data-filter-label') || group;
    }

    var panelTitle = document.querySelector('[data-filter-panel="' + group + '"] .category-filter-panel__title');
    return panelTitle ? panelTitle.textContent.trim() : titleCaseWords(group);
  }

  function syncCampaignOptions() {
    var payload = root.querySelector('[data-campaign-facets]');
    if (!payload) return;
    var rows;
    try {
      // Cache per script element: AJAX replaces the element when the dataset changes.
      // Accept the old array format while pages and fingerprinted assets roll out.
      rows = payload.campaignFacetRows;
      if (!rows) {
        var data = JSON.parse(payload.textContent);
        if (Array.isArray(data)) rows = data;
        else if (data.version === 1 && Array.isArray(data.options) && Array.isArray(data.rows)) {
          rows = data.rows.map(function (ids) {
            var row = Object.create(null);
            ids.forEach(function (id) {
              var option = data.options[id];
              if (!option || filterKeys.indexOf(option[0]) === -1) throw new Error('Invalid campaign facet');
              if (!row[option[0]]) row[option[0]] = [];
              row[option[0]].push(option[1]);
            });
            return row;
          });
        } else return;
        payload.campaignFacetRows = rows;
      }
    } catch (_) { return; }
    function matches(row, group, value) {
      return (row[group] || []).indexOf(value) !== -1 && filterKeys.every(function (other) {
        var selected = stagedState.filters[other] || [];
        return other === group || !selected.length || selected.some(function (v) { return (row[other] || []).indexOf(v) !== -1; });
      });
    }
    document.querySelectorAll('[data-filter-option]').forEach(function (input) {
      var group = input.getAttribute('data-filter-group'), value = input.value.toLowerCase();
      var selected = (stagedState.filters[group] || []).indexOf(value) !== -1;
      var available = selected || rows.some(function (row) { return matches(row, group, value); });
      input.toggleAttribute('data-campaign-unavailable', !available);
      var item = input.closest('li') || input.closest('label');
      if (item) { if (available) item.style.removeProperty('display'); else item.style.setProperty('display','none','important'); }
    });
    filterKeys.forEach(function (group) {
      var available = getFilterOptions(group).length > 0;
      document.querySelectorAll('.category-filter-bar__trigger[data-filter-group="' + group + '"]').forEach(function (button) {
        button.disabled = !available;
        button.hidden = !available;
        // Shared button styles can override the browser's default [hidden] display.
        if (available) button.style.removeProperty('display');
        else button.style.setProperty('display', 'none', 'important');
      });
    });
  }

  function getFilterOptions(group) {
    var seen = Object.create(null);
    var options = [];

    document.querySelectorAll('[data-filter-option][data-filter-group="' + group + '"]').forEach(function (input) {
      var value = (input.value || '').toLowerCase();
      if (!value || seen[value] || input.hasAttribute('data-campaign-unavailable')) return;
      seen[value] = true;
      options.push({
        value: value,
        label: (filterOptionLabels[group] && filterOptionLabels[group][value]) || titleCaseWords(value)
      });
    });

    return options;
  }

  function getSortOptions() {
    var options = [];
    var seen = Object.create(null);

    document.querySelectorAll('[data-filter-panel="sort"] .category-filter-panel__list a').forEach(function (link) {
      var href = link.getAttribute('href');
      var token = href
        ? resolveSortTokenFromLink(link, new URL(href, window.location.origin))
        : sortTokensByLabel[(link.textContent || '').trim().toLowerCase()] || 'popular';

      if (!token || seen[token]) return;
      seen[token] = true;
      options.push({
        value: token,
        label: (link.textContent || '').trim() || (sortLabels[token] || 'Best Sellers')
      });
    });

    return options;
  }

  function renderMobileOptionButtons(group, options) {
    if (!options.length) {
      return '<p class="category-filter-mobile__empty">No options available.</p>';
    }

    return '<div class="category-filter-mobile__option-grid">' + options.map(function (option) {
      var isSelected = group === 'sort'
        ? stagedState.sort === option.value
        : stagedState.filters[group] && stagedState.filters[group].indexOf(option.value) > -1;

      var dataAttribute = group === 'sort' ? 'data-mobile-sort-option' : 'data-mobile-filter-option';
      var valueAttribute = group === 'sort' ? 'data-sort-value' : 'data-filter-value';

      return '<button type="button" class="category-filter-mobile__option-button' + (isSelected ? ' is-selected' : '') + '" ' +
        dataAttribute + ' data-filter-group="' + escapeHtml(group) + '" ' + valueAttribute + '="' + escapeHtml(option.value) + '" aria-pressed="' + (isSelected ? 'true' : 'false') + '">' +
        escapeHtml(option.label) + '</button>';
    }).join('') + '</div>';
  }

  function renderMobileAppliedFilters() {
    var chips = '';

    filterKeys.forEach(function (group) {
      getDisplayFilterValues(group, stagedState.filters).forEach(function (value) {
        var labelMap = filterOptionLabels[group] || {};
        var chipLabel = labelMap[value] || titleCaseWords(value);
        chips += '<button type="button" class="category-filter-chip" data-filter-chip-remove data-filter-group="' + escapeHtml(group) + '" data-filter-value="' + escapeHtml(value) + '">' + escapeHtml(chipLabel) + ' \u00d7</button>';
      });
    });

    if (!chips) return '';

    return '<div class="category-filter-applied"><div class="category-filter-applied__header"><strong>Selected Filters</strong></div><div class="category-filter-applied__chips" data-all-filter-chips>' + chips + '</div></div>';
  }

  function renderMobileSheetMarkup(group) {
    if (group === 'sort') {
      return renderMobileOptionButtons(group, getSortOptions());
    }

    if (group === 'all-filters') {
      var sections = renderMobileAppliedFilters();

      filterKeys.forEach(function (filterGroup) {
        var options = getFilterOptions(filterGroup);
        if (!options.length) return;

        sections += '<section class="category-filter-mobile__section">' +
          '<p class="category-filter-group-title">' + escapeHtml(getFilterGroupLabel(filterGroup)) + '</p>' +
          renderMobileOptionButtons(filterGroup, options) +
          '</section>';
      });

      return sections || '<p class="category-filter-mobile__empty">No filters available.</p>';
    }

    return renderMobileOptionButtons(group, getFilterOptions(group));
  }

  function rerenderActiveMobileSheet() {
    if (!activeMobileGroup || !mobileSheetBody) return;

    var scrollTop = mobileSheetBody.scrollTop;
    mobileSheetBody.innerHTML = renderMobileSheetMarkup(activeMobileGroup);
    mobileSheetBody.scrollTop = scrollTop;
    renderAllFilterChips();
  }

  function toggleMobileFilterOption(group, value) {
    if (!group || !value || !stagedState.filters[group]) return;

    var index = stagedState.filters[group].indexOf(value);
    if (isSingleSelectFilterGroup(group)) {
      stagedState.filters[group] = index > -1 ? [] : [value];
    } else if (index > -1) {
      stagedState.filters[group].splice(index, 1);
    } else {
      stagedState.filters[group].push(value);
    }

    stagedState.page = 1;
  }

  function syncLocationAwareLinks() {
    var selectedLocation = appliedState.filters.location.length === 1
      ? appliedState.filters.location[0]
      : '';

    document.querySelectorAll('a[href^="/"]').forEach(function (link) {
      var rawHref = link.getAttribute('href') || '';
      if (!rawHref || rawHref.indexOf('//') === 0) return;

      var targetUrl;
      try {
        targetUrl = new URL(rawHref, window.location.origin);
      } catch (error) {
        return;
      }

      var trimmedPath = targetUrl.pathname.replace(/^\/+|\/+$/g, '');
      var segments = trimmedPath ? trimmedPath.split('/') : [];
      if (segments.length === 0 || segments.length > 2) return;

      var firstSegment = (segments[0] || '').toLowerCase();
      var secondSegment = (segments[1] || '').toLowerCase();

      if (isGiftCardsCategorySegment(firstSegment)) return;
      if (knownFeatureSlugs[firstSegment]) return;
      if (isAllExperiencesCategorySegment(firstSegment) && secondSegment && knownFeatureSlugs[secondSegment]) return;

      if (!knownCategorySlugs[firstSegment] && !knownSubCategorySlugs[firstSegment]) return;

      if (segments.length > 1 && knownLocationSlugs[(segments[1] || '').toLowerCase()]) {
        segments.splice(1, 1);
      }

      if (selectedLocation) {
        segments.splice(1, 0, selectedLocation);
      }

      targetUrl.pathname = '/' + segments.join('/') + '/';
      link.setAttribute('href', targetUrl.pathname + targetUrl.search + targetUrl.hash);
    });
  }

  function getFilterQueryParam(key) {
    if (key === 'category') return categoryFilterQueryParam;
    if (key === 'instantbook') return 'instantBook';
    return key;
  }

  function isSingleSelectFilterGroup(group) {
    if (root.getAttribute('data-search-single-select') === 'true') return true;
    return (group === 'category' && getFilterQueryParam('category') === 'category') || group === 'instantbook' || group === 'rating';
  }

  function isAllExperiencesCategorySegment(segment) {
    return String(segment || '').trim().toLowerCase() === 'all-experiences';
  }

  function isGiftCardsCategorySegment(segment) {
    return String(segment || '').trim().toLowerCase() === 'gift-cards';
  }

  function parsePathState(pathname) {
    var normalizedPath = String(pathname || window.location.pathname || '')
      .replace(/^\/+|\/+$/g, '');
    var segments = normalizedPath ? normalizedPath.split('/') : [];
    var pathState = {
      filters: {
        location: [],
        category: [],
        price: [],
        rating: [],
        instantbook: [],
        occasion: []
      }
    };

    segments.forEach(function (rawSegment, index) {
      var segment = String(rawSegment || '').trim().toLowerCase();
      if (!segment) return;

      if (isAllExperiencesCategorySegment(segment)) {
        return;
      }

      if (index === 0 && (knownCategorySlugs[segment] || knownSubCategorySlugs[segment])) {
        pathState.filters.category = [segment];
        return;
      }

      if (knownFeatureSlugs[segment]) return;

      if (knownLocationSlugs[segment]) {
        pathState.filters.location = [segment];
        return;
      }

      if (/^\d+-\d+$/.test(segment)) {
        pathState.filters.price = [segment];
        return;
      }

      if (knownOccasionSlugs[segment]) {
        pathState.filters.occasion = [segment];
        return;
      }

      if (pathState.filters.category.length === 0 && (knownCategorySlugs[segment] || knownSubCategorySlugs[segment])) {
        pathState.filters.category = [segment];
      }
    });

    return pathState;
  }

  function readStateFromUrl(search, pathname) {
    var params = new URLSearchParams(search || '');
    var pathState = parsePathState(pathname || window.location.pathname);
    var state = {
      filters: {
        location: splitCsv(params.get('location') || (root.getAttribute('data-campaign-slug') ? params.get('L') : '')),
        category: splitCsv(params.get(getFilterQueryParam('category'))),
        price: splitCsv(params.get('price')),
        rating: splitCsv(params.get('rating')),
        instantbook: splitCsv(params.get('instantBook')),
        occasion: splitCsv(params.get('occasion'))
      },
      sort: (params.get('sort') || root.getAttribute('data-initial-sort') || 'popular').toLowerCase(),
      page: parseInt(params.get('page') || root.getAttribute('data-initial-page') || '1', 10),
      items: params.get('items') || root.getAttribute('data-initial-items') || ''
    };

    filterKeys.forEach(function (key) {
      if (state.filters[key].length === 0 && pathState.filters[key] && pathState.filters[key].length > 0) {
        state.filters[key] = pathState.filters[key].slice();
      }
      if (state.filters[key].length === 0 && !root.getAttribute('data-campaign-slug')) {
        state.filters[key] = splitCsv(root.getAttribute('data-initial-' + key));
      }
    });

    return state;
  }

  function readSortTokenFromParams(params) {
    var explicitSort = String(params.get('sort') || '').toLowerCase();
    if (sortLabels[explicitSort]) return explicitSort;

    var legacySort = String(params.get('sortType') || params.get('s') || '').toLowerCase();
    if (legacySort === '0') return 'relevance';
    if (legacySort === '1') return 'popular';
    if (legacySort === '2') return 'price-asc';
    if (legacySort === '3') return 'price-desc';

    return '';
  }

  function resolveSortTokenFromLink(link, targetUrl) {
    var explicitSort = readSortTokenFromParams(targetUrl.searchParams);
    if (explicitSort) return explicitSort;

    var linkLabel = String(link && link.textContent ? link.textContent : '').trim().toLowerCase();
    return sortTokensByLabel[linkLabel] || 'popular';
  }

  function normalizeState(state) {
    var normalized = cloneState(state);
    if (isSingleSelectFilterGroup('category') && normalized.filters.category.length > 1) {
      normalized.filters.category = [normalized.filters.category[0]];
    }
    if (normalized.filters.rating.length > 1) {
      normalized.filters.rating = [normalized.filters.rating[0]];
    }
    normalized.filters.instantbook = normalized.filters.instantbook.some(function (value) {
      var normalizedValue = String(value || '').toLowerCase();
      return normalizedValue === 'true' || normalizedValue === '1' || normalizedValue === 'yes' || normalizedValue === 'on';
    }) ? ['true'] : [];
    // Server pagination uses numeric sort IDs; preserve them across AJAX/history navigation.
    normalized.sort = ({'0':'relevance','1':'popular','2':'price-asc','3':'price-desc'})[normalized.sort] || normalized.sort;
    if (!sortLabels[normalized.sort]) normalized.sort = 'popular';
    if (!normalized.page || normalized.page < 1 || Number.isNaN(normalized.page)) normalized.page = 1;
    if (normalized.items && !/^\d+$/.test(String(normalized.items))) normalized.items = '';
    return normalized;
  }

  function mergeStateWithLink(baseState, linkState, options) {
    var merged = cloneState(baseState);
    options = options || {};

    if (options.includeFilters) {
      filterKeys.forEach(function (key) {
        merged.filters[key] = linkState.filters[key].slice();
      });
    }

    if (linkState.sort) merged.sort = linkState.sort;
    if (linkState.items) merged.items = linkState.items;

    if (options.resetPageToFirst) {
      merged.page = 1;
    } else if (typeof linkState.page === 'number' && !Number.isNaN(linkState.page)) {
      merged.page = linkState.page;
    }

    return normalizeState(merged);
  }

  function readPartialRequestContext() {
    var context = {};
    var catId = root.getAttribute('data-context-cat-id');
    var subCategory = root.getAttribute('data-context-sub-category');
    var feature = root.getAttribute('data-context-feature');
    var pageType = root.getAttribute('data-context-page-type');

    if (catId) context.catID = catId;
    if (subCategory) {
      context.subCategory = subCategory;
      context.subCatName = subCategory;
    }
    if (feature) context.F = feature;
    if (pageType) context.pageType = pageType;

    return context;
  }

  function buildSearchParams(state, options) {
    options = options || {};
    var params = new URLSearchParams();

    filterKeys.forEach(function (key) {
      var requestValues = getDisplayFilterValues(key, state.filters);
      if (requestValues.length > 0) {
        params.set(getFilterQueryParam(key), requestValues.join(','));
      }
    });

    if (state.sort && state.sort !== 'popular') params.set('sort', state.sort);
    if (state.page > 1) params.set('page', String(state.page));
    if (state.items) params.set('items', String(state.items));

    if (options.includeContext) {
      Object.keys(partialRequestContext).forEach(function (key) {
        var hasExplicitSubCategoryFilter = params.has('subCategory') || params.has('subCatName');
        if ((key === 'subCategory' || key === 'subCatName') && hasExplicitSubCategoryFilter) {
          return;
        }
        if (partialRequestContext[key]) {
          params.set(key, partialRequestContext[key]);
        }
      });
    }

    var searchTerm = root.getAttribute('data-search-term');
    if (searchTerm) params.set('term', searchTerm);
    return params;
  }

  function buildPartialUrl(state) {
    var params = buildSearchParams(state, { includeContext: true });
    var campaignSlug = root.getAttribute("data-campaign-slug");
    if (campaignSlug) params.set("slug", campaignSlug);

    if (appliedState.filters.location.length > 0 && state.filters.location.length === 0) {
      params.set('loc', 'clear');
    }
    return params.toString() ? partialEndpoint + '?' + params.toString() : partialEndpoint;
  }

  function mapCategoryFacetKey() {
    return getFilterQueryParam('category') === 'subCategory' ? 'facets.subcategory' : 'facets.category';
  }

  function mapRatingFacetValue(value) {
    var normalized = (value || '').toLowerCase();
    if (normalized === '5plus') return '5';
    if (normalized === '4plus') return '4';
    if (normalized === '3plus') return '3';
    return normalized;
  }

  function mapInstantBookFacetValue() {
    return 'true';
  }

  function toOccasionFacetValue(value) {
    return String(value || '')
      .split('-')
      .map(function (segment) {
        return segment ? segment.charAt(0).toUpperCase() + segment.slice(1) : '';
      })
      .join(' ');
  }

  function buildFacetEntries(prefix, values, mapper) {
    if (!values || values.length === 0) return [];
    return values
      .map(function (value) {
        var mappedValue = mapper ? mapper(value) : value;
        if (!mappedValue) return '';
        return prefix + ':' + mappedValue;
      })
      .filter(function (entry) { return entry.length > 0; });
  }

  function buildFilterPayload(state) {
    var payload = [];
    var categoryId = partialRequestContext.catID;
    var itemCount = state.items || root.getAttribute('data-initial-items') || '';

    if (categoryId) payload.push(['facets.categoryid:' + categoryId]);

    var categoryEntries = buildFacetEntries(mapCategoryFacetKey(), getDisplayFilterValues('category', state.filters));
    if (categoryEntries.length > 0) payload.push(categoryEntries);

    var locationEntries = buildFacetEntries('facets.region', getDisplayFilterValues('location', state.filters));
    if (locationEntries.length > 0) payload.push(locationEntries);

    var priceEntries = buildFacetEntries('facets.price', getDisplayFilterValues('price', state.filters));
    if (priceEntries.length > 0) payload.push(priceEntries);

    var ratingEntries = buildFacetEntries('facets.rating', getDisplayFilterValues('rating', state.filters), mapRatingFacetValue);
    if (ratingEntries.length > 0) payload.push(ratingEntries);

    var instantBookEntries = buildFacetEntries('facets.instantbook', getDisplayFilterValues('instantbook', state.filters), mapInstantBookFacetValue);
    if (instantBookEntries.length > 0) payload.push(instantBookEntries);

    var occasionEntries = buildFacetEntries('facets.occasion', getDisplayFilterValues('occasion', state.filters), toOccasionFacetValue);
    if (occasionEntries.length > 0) payload.push(occasionEntries);

    payload.push(['facets.sortby:' + (state.sort || 'popular')]);
    if (itemCount) payload.push(['facets.items:' + itemCount]);

    return payload;
  }

  function buildPublicUrl(state) {
    var managedPath = root.getAttribute('data-managed-public-path');
    if (managedPath) {
      var friendlyCategory = root.getAttribute('data-friendly-category-path') === 'true';
      var managedParams = buildSearchParams(state, { includeContext: !friendlyCategory });
      if (friendlyCategory) {
        // Rebuild from the category so changing or clearing an occasion removes the old path segment.
        var segments = managedPath.split('/').filter(Boolean);
        var occasions = getDisplayFilterValues('occasion', state.filters);
        managedPath = '/' + segments[0] + '/';
        if (occasions.length === 1 && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(occasions[0])) {
          managedPath += occasions[0] + '/';
          managedParams.delete('occasion');
        }
        if (activeFeatureSegment) managedPath += activeFeatureSegment + '/';
      }

      if (friendlyCategory && activeFeatureSegment && !managedPath.endsWith('/' + activeFeatureSegment + '/')) managedParams.set('F', activeFeatureSegment);
      return managedPath + (managedParams.toString() ? '?' + managedParams.toString() : '');
    }
    var normalized = normalizeState(state);
    var params = new URLSearchParams();
    var rawCategoryValues = normalized.filters.category.slice();
    var categoryValues = getDisplayFilterValues('category', normalized.filters);
    var locationValues = getDisplayFilterValues('location', normalized.filters);
    var occasionValues = getDisplayFilterValues('occasion', normalized.filters);
    var priceValues = getDisplayFilterValues('price', normalized.filters);
    var isExclusiveOffersContext = pageContextType === 'exclusive-offers';

    if (isExclusiveOffersContext) {
      if (categoryValues.length > 0) params.set(getFilterQueryParam('category'), categoryValues.join(','));
      if (occasionValues.length > 0) params.set('occasion', occasionValues.join(','));
      if (locationValues.length > 0) params.set('location', locationValues.join(','));
      if (priceValues.length > 0) params.set('price', priceValues.join(','));
      if (normalized.filters.rating.length > 0) params.set('rating', normalized.filters.rating.join(','));
      if (normalized.filters.instantbook.length > 0) params.set('instantBook', normalized.filters.instantbook.join(','));
      if (normalized.sort && normalized.sort !== 'popular') params.set('sort', normalized.sort);
      if (normalized.page > 1) params.set('page', String(normalized.page));
      if (normalized.items) params.set('items', String(normalized.items));

      return '/' + (publicBaseSegment || 'exclusive-offers') + '/' + (params.toString() ? '?' + params.toString() : '');
    }

    var baseSegment = (categoryFilterQueryParam === 'subCategory' && publicBaseSegment)
      ? publicBaseSegment
      : (rawCategoryValues.length === 1 ? rawCategoryValues[0] : (publicBaseSegment || 'all-experiences'));
    var segments = [baseSegment];

    if (occasionValues.length === 1) segments.push(occasionValues[0]);
    if (activeFeatureSegment) segments.push(activeFeatureSegment);
    if (locationValues.length === 1) segments.push(locationValues[0]);
    if (priceValues.length === 1) segments.push(priceValues[0]);

    if (categoryValues.length > 1) params.set(getFilterQueryParam('category'), categoryValues.join(','));
    if (occasionValues.length > 1) params.set('occasion', occasionValues.join(','));
    if (locationValues.length > 1) params.set('location', locationValues.join(','));
    if (priceValues.length > 1) params.set('price', priceValues.join(','));
    if (normalized.filters.rating.length > 0) params.set('rating', normalized.filters.rating.join(','));
    if (normalized.filters.instantbook.length > 0) params.set('instantBook', normalized.filters.instantbook.join(','));
    if (normalized.sort && normalized.sort !== 'popular') params.set('sort', normalized.sort);
    if (normalized.page > 1) params.set('page', String(normalized.page));
    if (normalized.items) params.set('items', String(normalized.items));

    var path = '/' + segments.filter(function (segment) {
      return String(segment || '').trim().length > 0;
    }).join('/') + '/';

    return path + (params.toString() ? '?' + params.toString() : '');
  }

  function updateBrowserUrl(state, useReplace) {
    var nextPath = buildPublicUrl(state);
    var historyState = { categoryFilterState: state };
    if (useReplace) {
      history.replaceState(historyState, '', nextPath);
    } else {
      history.pushState(historyState, '', nextPath);
    }
  }

  function closePanels(options) {
    options = options || {};

    clearDesktopCloseTimer();

    document.querySelectorAll('[data-filter-panel]').forEach(function (panel) {
      panel.classList.remove('category-filter-panel--modal');
      panel.hidden = true;
    });
    document.querySelectorAll('[data-filter-group][aria-expanded]').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    });
    if (desktopFilterOverlay) desktopFilterOverlay.hidden = true;
    document.body.classList.remove('category-filter-desktop-modal-open');

    if (options.returnFocus && options.trigger && typeof options.trigger.focus === 'function') {
      options.trigger.focus();
    }
  }

  function isDesktopViewport() {
    return !window.matchMedia('(max-width: 767px)').matches;
  }

  function clearDesktopCloseTimer() {
    if (!desktopCloseTimer) return;
    window.clearTimeout(desktopCloseTimer);
    desktopCloseTimer = null;
  }

  function clearMobileSheetAnimationTimer() {
    if (!mobileSheetAnimationTimer) return;
    window.clearTimeout(mobileSheetAnimationTimer);
    mobileSheetAnimationTimer = null;
  }

  function scheduleDesktopClose() {
    if (!isDesktopViewport()) return;
    clearDesktopCloseTimer();
    desktopCloseTimer = window.setTimeout(function () {
      closePanels();
    }, 120);
  }

  function isDesktopModalPanelGroup(group) {
    return group === 'all-filters';
  }

  function showDesktopPanel(panel, trigger, group) {
    if (!panel) return;

    panel.hidden = false;
    if (trigger) trigger.setAttribute('aria-expanded', 'true');

    if (isDesktopModalPanelGroup(group)) {
      panel.classList.add('category-filter-panel--modal');
      if (desktopFilterOverlay) desktopFilterOverlay.hidden = false;
      document.body.classList.add('category-filter-desktop-modal-open');
      return;
    }

    if (desktopFilterOverlay) desktopFilterOverlay.hidden = true;
    document.body.classList.remove('category-filter-desktop-modal-open');
    panel.classList.remove('category-filter-panel--modal');
    positionDesktopPanel(panel, trigger);
  }

  function openPanel(group, trigger) {
    var panel = document.querySelector('[data-filter-panel="' + group + '"]');
    if (!panel) return;

    if (window.matchMedia('(max-width: 767px)').matches) {
      openMobileSheet(group, trigger);
      return;
    }

    var isOpen = !panel.hidden;
    closePanels();
    if (isOpen) return;

    showDesktopPanel(panel, trigger, group);
    focusFirstInteractiveElement(panel);
  }

  function focusFirstInteractiveElement(container) {
    if (!container) return;
    var focusable = container.querySelector('input, button, a[href], [tabindex]:not([tabindex="-1"])');
    if (focusable && typeof focusable.focus === 'function') {
      try {
        focusable.focus({ preventScroll: true });
      } catch (error) {
        focusable.focus();
      }
    }
  }

  function positionDesktopPanel(panel, trigger) {
    if (!desktopPanels || !panel || !trigger) return;

    panel.style.left = '0px';
    panel.style.top = '0px';

    var containerRect = desktopPanels.getBoundingClientRect();
    var triggerRect = trigger.getBoundingClientRect();
    var panelRect = panel.getBoundingClientRect();
    var left = triggerRect.left - containerRect.left;
    var top = triggerRect.bottom - containerRect.top + 6;

    var maxLeft = Math.max(0, containerRect.width - panelRect.width);
    left = Math.min(Math.max(0, left), maxLeft);
    top = Math.max(0, top);

    panel.style.left = left + 'px';
    panel.style.top = top + 'px';
  }

  function setLoadingState(isLoading) {
    root.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    root.classList.toggle('is-loading', isLoading);
    if (isLoading) {
      announceStatus('Loading filtered results.');
    }
  }

  function clearPendingResultsLoad() {
    if (!pendingLoadTimer) return;
    window.clearTimeout(pendingLoadTimer);
    pendingLoadTimer = null;
  }

  function abortInFlightRequest() {
    if (!inFlightController) return;
    inFlightController.abort();
    inFlightController = null;
  }

  function closeMobileSheet(options) {
    options = options || {};
    activeMobileGroup = '';
    if (!options.preserveDraftState) {
      stagedState = cloneState(appliedState);
    }
    clearMobileSheetAnimationTimer();
    if (mobileSheetOverlay) mobileSheetOverlay.classList.remove('is-open');
    if (mobileSheetDialog) mobileSheetDialog.classList.remove('is-open');
    document.body.classList.remove('category-filter-mobile-sheet-open');

    mobileSheetAnimationTimer = window.setTimeout(function () {
      if (mobileSheetOverlay) mobileSheetOverlay.hidden = true;
      if (mobileSheetDialog) mobileSheetDialog.hidden = true;
      if (mobileSheetDialog) mobileSheetDialog.removeAttribute('data-mobile-sheet-group');
      if (mobileSheetBody) mobileSheetBody.innerHTML = '';
      mobileSheetAnimationTimer = null;
      if (options.returnFocus && options.trigger && typeof options.trigger.focus === 'function') {
        options.trigger.focus();
      }
    }, 180);
  }

  function openMobileSheet(group, trigger) {
    if (!mobileSheetDialog || !mobileSheetBody) return;

    clearMobileSheetAnimationTimer();

    mobileSheetBody.innerHTML = renderMobileSheetMarkup(group);
    if (mobileSheetTitle) {
      mobileSheetTitle.textContent = (trigger && trigger.getAttribute('data-filter-label')) || 'Filters';
    }

    activeMobileGroup = group;
    if (mobileSheetOverlay) {
      mobileSheetOverlay.hidden = false;
      mobileSheetOverlay.classList.remove('is-open');
    }
    mobileSheetDialog.hidden = false;
    mobileSheetDialog.classList.remove('is-open');
    mobileSheetDialog.setAttribute('data-mobile-sheet-group', group);
    document.body.classList.add('category-filter-mobile-sheet-open');
    syncOptionInputs();
    renderAllFilterChips();
    lastFocusedElement = trigger || document.activeElement;

    window.requestAnimationFrame(function () {
      if (mobileSheetOverlay) mobileSheetOverlay.classList.add('is-open');
      if (mobileSheetDialog) mobileSheetDialog.classList.add('is-open');
    });

    var closeButton = mobileSheetDialog.querySelector('[data-mobile-sheet-close]');
    if (closeButton && typeof closeButton.focus === 'function') closeButton.focus();
  }

  function renderError(message) {
    var previousError = root.querySelector('[data-category-results-error]');
    if (previousError) previousError.remove();
    root.insertAdjacentHTML('afterbegin', '<div class="alert alert-warning" role="alert" data-category-results-error>' + message + ' <button type="button" class="btn btn-link btn-xs" data-category-results-retry>Retry</button></div>');
    announceStatus(message);
  }

  function updateSortTrigger() {
    var sortTrigger = document.querySelector('[data-filter-group="sort"]');
    if (!sortTrigger) return;

    var sortLabel = sortTrigger.querySelector('.category-filter-bar__trigger-label');
    var triggerValue = sortTrigger.querySelector('.category-filter-bar__trigger-value');
    var selectedSortLabel = sortLabels[appliedState.sort] || sortLabels.popular;
    var defaultSortLabel = sortTrigger.getAttribute('data-filter-label') || 'Sort by';

    if (sortLabel) sortLabel.textContent = defaultSortLabel;
    if (triggerValue) triggerValue.textContent = selectedSortLabel;
  }

  function updateSortPanelOptions() {
    var selectedSortLabel = sortLabels[appliedState.sort] || sortLabels.popular;

    document.querySelectorAll('[data-filter-panel="sort"] .category-filter-panel__list a').forEach(function (link) {
      var linkLabel = (link.textContent || '').trim();
      var isSelected = linkLabel === selectedSortLabel;

      if (isSelected) {
        link.setAttribute('selected', 'selected');
        link.setAttribute('aria-current', 'true');
      } else {
        link.removeAttribute('selected');
        link.removeAttribute('aria-current');
      }
    });
  }

  function getDisplayFilterValues(key, filters) {
    var values = (filters && filters[key] ? filters[key] : []).slice();

    if (key === 'category') {
      var pathCategoryContext = root.getAttribute('data-locked-subcategory') || '';
      var pathState = parsePathState(window.location.pathname);

      if (pathState && pathState.filters && pathState.filters.category && pathState.filters.category.length > 0) {
        pathCategoryContext = pathState.filters.category[0];
      }

      values = values.filter(function (value) {
        return !isAllExperiencesCategorySegment(value);
      });

      if (categoryFilterQueryParam === 'subCategory') {
        values = values.filter(function (value) {
          return !pathCategoryContext || value !== pathCategoryContext;
        });
      }
    }

    return values;
  }

  function updateFilterTriggerStates() {
    filterKeys.forEach(function (key) {
      var trigger = document.querySelector('[data-filter-group="' + key + '"]');
      if (!trigger) return;

      var triggerLabel = trigger.querySelector('.category-filter-bar__trigger-label');
      var triggerCount = trigger.querySelector('[data-filter-group-count]');
      if (!triggerLabel) return;

      var selectedValues = getDisplayFilterValues(key, appliedState.filters);
      var selectedCount = selectedValues.length;
      var defaultLabel = trigger.getAttribute('data-filter-label') || key;
      var isDesktop = isDesktopViewport();
      trigger.classList.toggle('is-active', selectedCount > 0);
      var labelNode = trigger.querySelector('.category-filter-bar__trigger-label');
      if (!labelNode) return;

      if (triggerCount) {
        if (!isDesktop && selectedCount > 0) {
          triggerCount.textContent = String(selectedCount);
          triggerCount.hidden = false;
        } else {
          triggerCount.textContent = '0';
          triggerCount.hidden = true;
        }
      }

      if (!isDesktop && selectedCount > 0) {
        labelNode.textContent = defaultLabel;
        return;
      }

      if (key === 'location' && selectedCount > 0) {
        var activeLabelMap = filterOptionLabels[key] || {};
        labelNode.textContent = selectedValues
          .map(function (value) {
            return activeLabelMap[value] || titleCaseWords(value);
          })
          .join(', ');
        return;
      }

      if (key === 'category' && selectedCount > 0) {
        var categoryLabelMap = filterOptionLabels.category || {};
        labelNode.textContent = selectedValues
          .map(function (value) {
            return categoryLabelMap[value] || titleCaseWords(value);
          })
          .join(', ');
        return;
      }

      if (key === 'instantbook' && selectedCount > 0) {
        labelNode.textContent = 'Instant Book On';
        return;
      }

      labelNode.textContent = selectedCount > 0 ? defaultLabel + ' (' + selectedCount + ')' : defaultLabel;
    });

    var allTrigger = document.querySelector('[data-filter-group="all-filters"]');
    if (allTrigger) {
      var allTriggerLabel = allTrigger.querySelector('.category-filter-bar__trigger-label');
      var allTriggerCount = allTrigger.querySelector('[data-filter-count]');
      var allCount = 0;
      filterKeys.forEach(function (key) {
        allCount += getDisplayFilterValues(key, appliedState.filters).length;
      });
      var allDefaultLabel = allTrigger.getAttribute('data-filter-label') || 'All Filters';
      allTrigger.classList.toggle('is-active', allCount > 0);
      var allLabelNode = allTrigger.querySelector('.category-filter-bar__trigger-label');
      if (!allLabelNode) return;
      allLabelNode.textContent = allCount > 0 ? allDefaultLabel + ' (' + allCount + ')' : allDefaultLabel;
      if (allTriggerCount) {
        if (allCount > 0) {
          allTriggerCount.textContent = String(allCount);
          allTriggerCount.hidden = false;
        } else {
          allTriggerCount.textContent = '0';
          allTriggerCount.hidden = true;
        }
      }
    }
  }

  function renderAllFilterChips() {
    document.querySelectorAll('[data-all-filter-chips]').forEach(function (container) {
      container.textContent = '';
      var hasChips = false;

      filterKeys.forEach(function (group) {
        getDisplayFilterValues(group, stagedState.filters).forEach(function (value) {
          var labelMap = filterOptionLabels[group] || {};
          var chipLabel = labelMap[value] || titleCaseWords(value);
          var chip = document.createElement('button');

          chip.type = 'button';
          chip.className = 'category-filter-chip';
          chip.setAttribute('data-filter-chip-remove', '');
          chip.setAttribute('data-filter-group', group);
          chip.setAttribute('data-filter-value', value);
          chip.textContent = chipLabel + ' \u00d7';

          container.appendChild(chip);
          hasChips = true;
        });
      });

      if (!hasChips) {
        var emptyState = document.createElement('span');
        emptyState.className = 'text-muted';
        emptyState.textContent = 'No filters selected.';
        container.appendChild(emptyState);
      }
    });

    updateMobileApplyLabel();
  }

  function updateMobileApplyLabel() {
    var applyButton = document.querySelector('[data-mobile-sheet-apply]');
    if (!applyButton) return;
    applyButton.textContent = 'Apply Filter';
  }

  function syncOptionInputs() {
    syncCampaignOptions();
    document.querySelectorAll('[data-filter-option]').forEach(function (input) {
      var key = input.getAttribute('data-filter-group');
      var value = (input.value || '').toLowerCase();
      if (!key || !value || !stagedState.filters[key]) return;
      var isChecked = stagedState.filters[key].indexOf(value) > -1;
      input.checked = isChecked;
      if (isChecked) {
        input.setAttribute('checked', 'checked');
      } else {
        input.removeAttribute('checked');
      }

      var styledCheckbox = input.parentElement;
      if (styledCheckbox && styledCheckbox.classList.contains('new-checkbox')) {
        styledCheckbox.classList.toggle('checked', isChecked);
      }
    });
  }

  function loadResults(nextState, options) {
    options = options || {};
    var normalized = normalizeState(nextState);
    var currentRequest = ++requestNonce;
    var keepDesktopPanelOpen = !!options.keepDesktopPanelOpen && isDesktopViewport();
    var keepMobileSheetOpen = !!options.keepMobileSheetOpen && !isDesktopViewport() && !!activeMobileGroup;
    var activeDesktopTrigger = keepDesktopPanelOpen
      ? document.querySelector('[data-filter-group][aria-expanded="true"]')
      : null;
    var activeMobileSheetGroup = keepMobileSheetOpen ? activeMobileGroup : '';
    var activeMobileTrigger = activeMobileSheetGroup
      ? document.querySelector('[data-filter-group="' + activeMobileSheetGroup + '"]')
      : null;

    clearPendingResultsLoad();
    abortInFlightRequest();
    inFlightController = new AbortController();
    lastRequestedState = cloneState(normalized);

    setLoadingState(true);

    return fetch(buildPartialUrl(normalized), {
      method: 'GET',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      signal: inFlightController.signal,
      credentials: 'same-origin'
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to fetch filtered results.');
        return response.text();
      })
      .then(function (html) {
        if (currentRequest !== requestNonce) return;
        var responseDocument = new DOMParser().parseFromString(html, 'text/html');
        if (!responseDocument.querySelector('[data-results-partial="category-list"][data-total-records]')) {
          throw new Error('Unexpected catalogue response.');
        }
        root.innerHTML = html;
        appliedState = cloneState(normalized);
        stagedState = cloneState(normalized);
        syncPrimaryNavLocationLinks();
        updateSortTrigger();
        updateSortPanelOptions();
        updateFilterTriggerStates();
        syncOptionInputs();
        renderAllFilterChips();
        syncEditorialVisibility();
        syncResultsCount();
        syncLocationAwareLinks();

        if (keepDesktopPanelOpen && activeDesktopTrigger) {
          var activeGroup = activeDesktopTrigger.getAttribute('data-filter-group');
          var activePanel = activeGroup ? document.querySelector('[data-filter-panel="' + activeGroup + '"]') : null;
          if (activePanel) {
            showDesktopPanel(activePanel, activeDesktopTrigger, activeGroup);
          }
        } else if (keepMobileSheetOpen && activeMobileSheetGroup) {
          openMobileSheet(activeMobileSheetGroup, activeMobileTrigger || lastFocusedElement);
        } else {
          closePanels();
          closeMobileSheet();
        }

        if (options.updateHistory) {
          updateBrowserUrl(appliedState, !!options.replaceHistory);
        }
        announceStatus('Results updated.');

        if (options.scrollToTop) {
          var catalog = document.getElementById('catalog');
          if (catalog) catalog.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;
        renderError('We could not refresh the results. Please try again.');
      })
      .finally(function () {
        if (currentRequest === requestNonce) {
          setLoadingState(false);
          inFlightController = null;
        }
      });
  }

  function scheduleLoadResults(nextState, options) {
    var scheduledState = cloneState(normalizeState(nextState));
    var scheduledOptions = Object.assign({}, options || {});

    clearPendingResultsLoad();
    abortInFlightRequest();

    pendingLoadTimer = window.setTimeout(function () {
      pendingLoadTimer = null;
      loadResults(scheduledState, scheduledOptions);
    }, filterRequestDebounceMs);
  }

  document.addEventListener('click', function (event) {
    var retryButton = event.target.closest('[data-category-results-retry]');
    if (retryButton) {
      event.preventDefault();
      if (lastRequestedState) {
        loadResults(lastRequestedState, { updateHistory: false });
      }
      return;
    }

    var mobileClose = event.target.closest('[data-mobile-sheet-close], [data-mobile-sheet-overlay]');
    if (mobileClose) {
      event.preventDefault();
      closeMobileSheet({ returnFocus: true, trigger: lastFocusedElement });
      return;
    }

    var mobileFilterOption = event.target.closest('[data-mobile-filter-option]');
    if (mobileFilterOption) {
      event.preventDefault();
      toggleMobileFilterOption(
        mobileFilterOption.getAttribute('data-filter-group'),
        (mobileFilterOption.getAttribute('data-filter-value') || '').toLowerCase()
      );
      rerenderActiveMobileSheet();
      return;
    }

    var mobileSortOption = event.target.closest('[data-mobile-sort-option]');
    if (mobileSortOption) {
      event.preventDefault();
      stagedState.sort = (mobileSortOption.getAttribute('data-sort-value') || 'popular').toLowerCase();
      stagedState.page = 1;
      rerenderActiveMobileSheet();
      return;
    }

    var desktopModalClose = event.target.closest('[data-desktop-filter-modal-close], [data-desktop-filter-overlay]');
    if (desktopModalClose) {
      event.preventDefault();
      var expandedDesktopTrigger = document.querySelector('[data-filter-group][aria-expanded="true"]');
      closePanels({ returnFocus: true, trigger: expandedDesktopTrigger });
      return;
    }

    var mobileApply = event.target.closest('[data-mobile-sheet-apply]');
    if (mobileApply) {
      event.preventDefault();
      stagedState.page = 1;
      loadResults(stagedState, { updateHistory: true });
      return;
    }

    var mobileReset = event.target.closest('[data-mobile-sheet-reset]');
    if (mobileReset) {
      event.preventDefault();
      var groupToReset = activeMobileGroup === 'all-filters' ? 'all' : activeMobileGroup;
      if (groupToReset === 'sort') {
        stagedState.sort = 'popular';
      } else if (groupToReset === 'all') {
        stagedState.filters = { location: [], category: [], price: [], rating: [], instantbook: [], occasion: [] };
      } else if (stagedState.filters[groupToReset]) {
        stagedState.filters[groupToReset] = [];
      }
      stagedState.page = 1;
      rerenderActiveMobileSheet();
      return;
    }

    var removeChip = event.target.closest('[data-filter-chip-remove]');
    if (removeChip) {
      event.preventDefault();
      var chipGroup = removeChip.getAttribute('data-filter-group');
      var chipValue = (removeChip.getAttribute('data-filter-value') || '').toLowerCase();
      if (!chipGroup || !chipValue || !stagedState.filters[chipGroup]) return;
      stagedState.filters[chipGroup] = stagedState.filters[chipGroup].filter(function (entry) {
        return entry !== chipValue;
      });
      stagedState.page = 1;
      if (mobileSheetDialog && !mobileSheetDialog.hidden) {
        rerenderActiveMobileSheet();
      } else {
        syncOptionInputs();
        renderAllFilterChips();
      }
      return;
    }

    var applyBtn = event.target.closest('[data-filter-apply]');
    if (applyBtn) {
      event.preventDefault();
      stagedState.page = 1;
      loadResults(stagedState, { updateHistory: true });
      return;
    }

    var resetBtn = event.target.closest('[data-filter-reset]');
    if (resetBtn) {
      event.preventDefault();
      var resetGroup = resetBtn.getAttribute('data-filter-group') || 'all';
      if (resetGroup === 'all') {
        stagedState.filters = { location: [], category: [], price: [], rating: [], instantbook: [], occasion: [] };
        stagedState.page = 1;
      } else if (stagedState.filters[resetGroup]) {
        stagedState.filters[resetGroup] = [];
        stagedState.page = 1;
      }
      syncOptionInputs();
      renderAllFilterChips();
      loadResults(stagedState, {
        updateHistory: true,
        keepDesktopPanelOpen: true
      });
      return;
    }

    var trigger = event.target.closest('[data-filter-group]');
    if (trigger && trigger.tagName === 'BUTTON') {
      var group = trigger.getAttribute('data-filter-group');
      if (group) {
        event.preventDefault();
        openPanel(group, trigger);
      }
      return;
    }

    var actionLink = event.target.closest('a[href]');
    if (!actionLink) return;

    var insidePagination = actionLink.closest('[data-category-pagination]');
    var insideSortPanel = actionLink.closest('[data-filter-panel="sort"]');
    if (!insidePagination && !insideSortPanel) return;

    if (actionLink.hasAttribute('disabled') || actionLink.getAttribute('aria-disabled') === 'true') {
      event.preventDefault();
      return;
    }

    var targetUrl = new URL(actionLink.href, window.location.origin);
    event.preventDefault();

    var stateFromLink = normalizeState(readStateFromUrl(targetUrl.search, targetUrl.pathname));
    var nextState = insideSortPanel
      ? mergeStateWithLink(appliedState, stateFromLink, { resetPageToFirst: true })
      : mergeStateWithLink(appliedState, stateFromLink, { includeFilters: true });

    if (insideSortPanel) {
      nextState.sort = resolveSortTokenFromLink(actionLink, targetUrl);
      nextState = normalizeState(nextState);
    }

    stagedState = cloneState(nextState);
    loadResults(nextState, {
      updateHistory: true,
      scrollToTop: !!insidePagination
    });
  });

  document.addEventListener('change', function (event) {
    var option = event.target.closest('[data-filter-option]');
    if (!option) return;

    var group = option.getAttribute('data-filter-group');
    var value = (option.value || '').toLowerCase();
    if (!group || !value || !stagedState.filters[group]) return;

    var index = stagedState.filters[group].indexOf(value);
    if (option.checked && isSingleSelectFilterGroup(group)) {
      stagedState.filters[group] = [value];
      syncOptionInputs();
    } else if (option.checked && index === -1) {
      stagedState.filters[group].push(value);
    }
    if (!option.checked && index > -1) stagedState.filters[group].splice(index, 1);

    stagedState.page = 1;
    renderAllFilterChips();

    var optionIsInMobileSheet = !!(mobileSheetBody && mobileSheetBody.contains(option));
    if (optionIsInMobileSheet || !isDesktopViewport()) {
      syncOptionInputs();
      return;
    }

    scheduleLoadResults(stagedState, {
      updateHistory: true,
      keepDesktopPanelOpen: isDesktopViewport() && !(mobileSheetBody && mobileSheetBody.contains(option))
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (mobileSheetDialog && !mobileSheetDialog.hidden) {
      closeMobileSheet({ returnFocus: true, trigger: lastFocusedElement });
      return;
    }
    var expandedTrigger = document.querySelector('[data-filter-group][aria-expanded="true"]');
    closePanels({ returnFocus: true, trigger: expandedTrigger });
  });

  document.addEventListener('click', function (event) {
    if (!filterBar || !desktopPanels) return;
    var clickedTrigger = event.target.closest('[data-filter-group]');
    if (clickedTrigger) return;
    if (desktopPanels.contains(event.target)) return;
    if (filterBar.contains(event.target)) return;

    closePanels();
  });

  if (filterBar) {
    filterBar.addEventListener('mouseenter', clearDesktopCloseTimer);
    filterBar.addEventListener('mouseleave', scheduleDesktopClose);
  }

  if (desktopPanels) {
    desktopPanels.addEventListener('mouseenter', clearDesktopCloseTimer);
    desktopPanels.addEventListener('mouseleave', scheduleDesktopClose);
  }

  window.addEventListener('popstate', function () {
    var stateFromUrl = normalizeState(readStateFromUrl(window.location.search, window.location.pathname));
    // Anchor navigation also emits popstate; it must not reload unchanged results.
    if (!inFlightController && JSON.stringify(stateFromUrl) === JSON.stringify(appliedState)) return;
    loadResults(stateFromUrl, { updateHistory: false, replaceHistory: true });
  });

  window.addEventListener('resize', function () {
    if (window.matchMedia('(min-width: 768px)').matches) {
      closeMobileSheet();
    }
    updateFilterTriggerStates();
    updateSortTrigger();
    refreshFilterBarStickyState();
    syncFilterBarStickyLayout();
  });

  bindFilterBarStickyState();
  updateBrowserUrl(appliedState, true);
  syncPrimaryNavLocationLinks();
  updateSortTrigger();
  updateSortPanelOptions();
  updateFilterTriggerStates();
  syncOptionInputs();
  renderAllFilterChips();
  syncEditorialVisibility();
  syncResultsCount();
  syncLocationAwareLinks();
})();
